import { NgModule } from '@angular/core';
import { ShipmentRouteRoutingModule } from 'app-modules/shipment-route/shipment-route-routing.module';


@NgModule({
  imports: [
     ShipmentRouteRoutingModule
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class ShipmentRouteModule { }


